"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteClassConfigurationDialogModule = /** @class */ (function () {
    function DeleteClassConfigurationDialogModule() {
    }
    return DeleteClassConfigurationDialogModule;
}());
exports.DeleteClassConfigurationDialogModule = DeleteClassConfigurationDialogModule;
